import React from 'react'
import "./Template.css"
function Template() {
  return (
    <div className='big-img'>
        <div className='template'>
        <div className='appstore'></div>
        {/* <img src='image/bob1.png' width="100px" height="100px"/> */}
        <div className='playstore'></div>
        </div>
    </div>
  )
}

export default Template